export const GAME_STATES = {
  NOT_STARTED: "NOT_STARTED",
  STARTED: "STARTED",
  FAIL: "FAIL"
};
